import type { UserInfo } from '@tencent/docs-login/dist/utils/user';

/* eslint-disable no-param-reassign */
const setUserInfoForClientVars = (clientVars, user?: UserInfo): void => {
    clientVars.userInfo = user || {};
    clientVars.userName = user?.nick;
    clientVars.userPic = user?.avatar;
    clientVars.userLoginCorpId = user?.corpId;
    clientVars.userLoginCorpName = user?.corpName;
    // @ts-ignore 这里实际有值，但是类型定义中却刻意被 Omit 了，暂时忽略
    clientVars.vipInfo = user?.vipInfo;
};
export default setUserInfoForClientVars;
